// Event Emitter pour la communication entre composants
// Permet de synchroniser les données entre différentes pages du dashboard

class EventEmitter {
  constructor() {
    this.events = {};
  }

  // S'abonner à un événement
  on(eventName, callback) {
    if (!this.events[eventName]) {
      this.events[eventName] = [];
    }
    this.events[eventName].push(callback);

    // Retourner une fonction pour se désabonner
    return () => {
      this.off(eventName, callback);
    };
  }

  // Se désabonner d'un événement
  off(eventName, callback) {
    if (!this.events[eventName]) return;
    
    this.events[eventName] = this.events[eventName].filter(
      cb => cb !== callback
    );
  }

  // Émettre un événement
  emit(eventName, data) {
    if (!this.events[eventName]) return;
    
    this.events[eventName].forEach(callback => {
      try {
        callback(data);
      } catch (error) {
        console.error(`Error in event handler for ${eventName}:`, error);
      }
    });
  }

  // Effacer tous les listeners d'un événement
  removeAllListeners(eventName) {
    if (eventName) {
      delete this.events[eventName];
    } else {
      this.events = {};
    }
  }
}

// Instance singleton
const eventEmitter = new EventEmitter();

// Types d'événements supportés
export const EVENTS = {
  // CV Events
  CV_DELETED: 'cv:deleted',
  CV_UPLOADED: 'cv:uploaded',
  CV_UPDATED: 'cv:updated',
  
  // Candidate Card Events  
  CANDIDATE_CREATED: 'candidate:created',
  CANDIDATE_UPDATED: 'candidate:updated',
  CANDIDATE_DELETED: 'candidate:deleted',
  CANDIDATE_SHARED_TO_KANBAN: 'candidate:shared_to_kanban',
  CANDIDATE_UNSHARED_FROM_KANBAN: 'candidate:unshared_from_kanban',
  
  // Application Events
  APPLICATION_CREATED: 'application:created',
  APPLICATION_DELETED: 'application:deleted',
  
  // Kanban Events
  KANBAN_REFRESH_NEEDED: 'kanban:refresh_needed',
  KANBAN_CANDIDATE_MOVED: 'kanban:candidate_moved',
  
  // Global Events
  DATA_SYNC_NEEDED: 'data:sync_needed'
};

export default eventEmitter;